import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';

const MinoanWatchtower = {
  id: '31',
  name: 'Minoan Watchtower',
  width: 2,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'minoanEra',
  icon: 'Minoan_Watchtower',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Minoan_Watchtower',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([
        300, 350, 400, 450, 500, 550, 600, 650, 700, 750,
        850, 950, 1050, 1150, 1250, 1350, 1450, 1550, 1650, 1750,
        1850, 1950, 2050, 2150, 2250, 2350, 2450, 2550, 2650, 2750,
        2850, 2950, 3050, 3150, 3250, 3350, 3450, 3550, 3650, 3750,
      ]),
      CultureRange.asFlat(3),
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          if (level <= 2) {
            return 1;
          }
          if (level <= 9) {
            return 2;
          }
          if (level <= 16) {
            return 3;
          }
          if (level <= 23) {
            return 4;
          }
          if (level <= 30) {
            return 5;
          }
          if (level <= 37) {
            return 6;
          }
          return 7;
        }
      ),
    ),
  ]),
};

export default MinoanWatchtower;
